if (!customElements.get('share-button')) {
  customElements.define(
    'share-button',
    class ShareButton extends DetailsDisclosure {
      constructor() {
        super();

        this.elements = {
          shareButton: this.querySelector('button'),
          shareSummary: this.querySelector('summary'),
          closeButton: this.querySelector('.share-button__close'),
          successMessage: this.querySelector('[id^="ShareMessage"]'),
          urlInput: this.querySelector('input'),
        };
        this.urlToShare = this.elements.urlInput ? this.elements.urlInput.value : document.location.href;
        this.labelNode = Array.from(this.elements.shareButton.childNodes).find(
          (node) => node.nodeType === Node.TEXT_NODE && node.textContent.trim()
        );
        this.defaultLabel = this.labelNode ? this.labelNode.textContent : '';
        this.resetTimer = null;

        this.mainDetailsToggle.setAttribute('hidden', '');
        this.elements.shareButton.classList.remove('hidden');
        this.elements.shareButton.addEventListener('click', this.copyToClipboard.bind(this));
      }

      copyToClipboard() {
        const copyPromise = navigator.clipboard?.writeText
          ? navigator.clipboard.writeText(this.urlToShare)
          : this.copyWithFallback(this.urlToShare);

        copyPromise.then(() => this.showSuccess()).catch(() => this.showManualFallback());
      }

      copyWithFallback(url) {
        return new Promise((resolve, reject) => {
          const textArea = document.createElement('textarea');
          textArea.value = url;
          textArea.setAttribute('readonly', '');
          textArea.style.position = 'fixed';
          textArea.style.opacity = '0';
          document.body.appendChild(textArea);
          textArea.select();

          try {
            document.execCommand('copy') ? resolve() : reject();
          } catch (error) {
            reject(error);
          } finally {
            textArea.remove();
          }
        });
      }

      showSuccess() {
        const message = window.accessibilityStrings.shareSuccess || 'Link copied';
        this.elements.shareButton.setAttribute('aria-label', message);

        if (this.labelNode) {
          this.labelNode.textContent = ` ${message}`;
        }

        clearTimeout(this.resetTimer);
        this.resetTimer = setTimeout(() => {
          this.elements.shareButton.removeAttribute('aria-label');
          if (this.labelNode) this.labelNode.textContent = this.defaultLabel;
        }, 2000);
      }

      showManualFallback() {
        this.mainDetailsToggle.removeAttribute('hidden');
        this.mainDetailsToggle.setAttribute('open', '');
        this.elements.shareButton.classList.add('hidden');
        this.elements.urlInput.focus();
        this.elements.urlInput.select();
      }

      close() {
        this.mainDetailsToggle.removeAttribute('open');
        this.elements.shareButton.classList.remove('hidden');
        this.mainDetailsToggle.setAttribute('hidden', '');
        this.elements.shareButton.focus();
      }

      updateUrl(url) {
        this.urlToShare = url;
        this.elements.urlInput.value = url;
      }
    }
  );
}
